import { gsap, ScrollTrigger } from '../global/gsap';

const initHeader = (header) => {
    const headerEl = document.querySelector('.js-header');
    const firstSection = document.querySelector('.js-begin-content');

    if (!firstSection) return;

    const wrapperTl = gsap.timeline({
        scrollTrigger: {
            trigger: firstSection,
            start: 'top +=60',
            onEnter: () => {
                headerEl.classList.add('has-scrolled');
            },
            onLeaveBack: () => {
                headerEl.classList.remove('has-scrolled');
            }
        }
    });
};

export default initHeader;
